module.exports = __webpack_public_path__ + "img/accesories.b80ba507.jpg";